import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { CallsIcon, isActivePath, PhoneIcon, UsersIcon } from './nav/items'

// MobileNav stays narrower than the desktop sidebar on purpose — bottom
// bars get unreadable past 4 items on small screens. Recordings/Settings
// live in the (...) menu of /staff or in the desktop sidebar only.
interface MobileTab {
  path: string
  label: string
  icon: ReactNode
}

const tabs: MobileTab[] = [
  { path: '/staff', label: 'Phones', icon: PhoneIcon },
  { path: '/staff/calls', label: 'Calls', icon: CallsIcon },
  { path: '/staff/access-keys', label: 'Keys', icon: UsersIcon },
]

export function MobileNav() {
  const location = useLocation()

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
      <div className="flex justify-around py-2">
        {tabs.map(tab => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`flex flex-col items-center gap-0.5 px-3 py-1.5 text-[11px] font-medium transition-colors ${
              isActivePath(location.pathname, tab.path)
                ? 'text-blue-600 dark:text-blue-400'
                : 'text-gray-400 dark:text-gray-500'
            }`}
          >
            {tab.icon}
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  )
}
